<h2 mat-dialog-title>Apply Mastersuite</h2>

<mat-dialog-content>
  <div class="product-summary">
    <table class="product-table">
      <thead>
        <tr>
          <th>Barcode</th>
          <th>Reference</th>
          <th>Description</th>
        </tr>
      </thead>
      <tbody>
        @for (product of data.products; track product) {
          <tr>
            <td>{{ product.barcode }}</td>
            <td>{{ product.reference }}</td>
            <td>{{ product.description }}</td>
          </tr>
        }
      </tbody>
    </table>
    <div class="product-count">{{ data.products.length }} product(s) selected</div>
  </div>

  @if (authService.hasPermission(Permission.MasterSuitesFull)) {
    <div class="settings-form">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Mastersuite</mat-label>
        <input
          type="text"
          placeholder="Search mastersuites"
          matInput
          [formControl]="mastersuiteControl"
          [matAutocomplete]="auto"
          />
        <mat-autocomplete
          #auto="matAutocomplete"
          [displayWith]="displayFn"
          (optionSelected)="onMastersuiteSelected($event.option.value)"
          >
          @for (mastersuite of mastersuiteFilteredOptions | async; track mastersuite) {
            <mat-option
              [value]="mastersuite"
              >
              {{ mastersuite.name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
      @if (selectedMastersuite) {
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Settings Variant</mat-label>
          <mat-select [(ngModel)]="selectedVariant" [panelWidth]="null">
            @for (variant of variants; track variant) {
              <mat-option [value]="variant">
                {{ variant.name }}
              </mat-option>
            }
          </mat-select>
          @if (variants.length === 0) {
            <mat-hint>No Settings Variants Available</mat-hint>
          }
        </mat-form-field>
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Enhancement Variant</mat-label>
          <mat-select [(ngModel)]="selectedEnhancementVariant" [panelWidth]="null">
            <mat-option [value]="undefined">None</mat-option>
            @for (enhancement of enhancementVariants; track enhancement) {
              <mat-option [value]="enhancement">
                {{ enhancement.name }}
              </mat-option>
            }
          </mat-select>
          @if (enhancementVariants.length === 0) {
            <mat-hint>No Enhancement Variants Available</mat-hint>
          }
        </mat-form-field>
      }
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button matDialogClose [disabled]="isApplying">Cancel</button>
  @if (authService.hasPermission(Permission.MasterSuitesFull)) {
    <button
      mat-raised-button
      color="primary"
      (click)="onApply()"
      [disabled]="!selectedMastersuite || isApplying"
      >
      @if (isApplying) {
        <mat-spinner diameter="20" class="inline-spinner"></mat-spinner>
      }
      @if (!isApplying) {
        <span>Apply</span>
      }
    </button>
  }
</mat-dialog-actions>
